export default "__VITE_ASSET__cGvY85GO__"